import { BottomNavigation, type BottomNavigationItem } from '@miniapp-core/ui-kit';
import { useNavigate } from 'react-router-dom';

export type MainMiniappRoute = 'home' | 'materials' | 'events' | 'navigator';

interface MainMiniappBottomNavLabels {
  home: string;
  materials: string;
  events: string;
  navigator: string;
}

interface MainMiniappBottomNavProps {
  activeRoute: MainMiniappRoute;
  labels?: Partial<MainMiniappBottomNavLabels>;
}

const defaultLabels: MainMiniappBottomNavLabels = {
  home: 'Главная',
  materials: 'Материалы',
  events: 'События',
  navigator: 'Навигатор',
};

export default function MainMiniappBottomNav({ activeRoute, labels }: MainMiniappBottomNavProps) {
  const navigate = useNavigate();
  const resolvedLabels = { ...defaultLabels, ...labels };

  const items: BottomNavigationItem[] = [
    {
      id: 'home',
      label: resolvedLabels.home,
      icon: <span className="material-symbols-outlined">home</span>,
      onSelect: () => navigate('/'),
    },
    {
      id: 'materials',
      label: resolvedLabels.materials,
      icon: <span className="material-symbols-outlined">library_books</span>,
      onSelect: () => navigate('/digital-media/'),
    },
    {
      id: 'events',
      label: resolvedLabels.events,
      icon: <span className="material-symbols-outlined">event_available</span>,
      onSelect: () => navigate('/events/'),
    },
    {
      id: 'navigator',
      label: resolvedLabels.navigator,
      icon: <span className="material-symbols-outlined">near_me</span>,
      onSelect: () => navigate('/digital-media/navigator'),
    },
  ];

  return <BottomNavigation items={items} activeId={activeRoute} />;
}
